<nz-modal [(nzVisible)]="isVisible" nzTitle="Add New Driver" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
  <ng-container *nzModalContent>
    <section id="driverSegment" class="">
      <nz-card class="grid grid-cols-1 gap-4">
        <div>
          <form nz-form [formGroup]="driverForm" [nzLayout]="'vertical'">
            <h5 class="text-primary">Driver Type</h5>
            <div class="grid gap-3">
              <div>
                <nz-form-label nzRequired>Driver Segment</nz-form-label>
                <nz-form-item>
                  <nz-form-control [nzErrorTip]="driverSegmentError">
                    <nz-select class="w-full" formControlName="driverSegment" nzPlaceHolder="Select Segment">
                      <nz-option nzValue="OUTSOURCE_DRIVER" nzLabel="Outsource Driver"></nz-option>
                      <nz-option nzValue="SR_DRIVER" nzLabel="SR Driver"></nz-option>
                    </nz-select>
                  </nz-form-control>
                  <ng-template #driverSegmentError>
                    <span *ngIf="formErrors.driverSegment.required">Please select a segment. </span>
                  </ng-template>
                </nz-form-item>
              </div>
              <!--          <div *ngIf="isOutsourceDriver">-->
              <!--            <nz-form-label>Supplier</nz-form-label>-->
              <!--            <nz-form-item>-->
              <!--              <nz-form-control>-->
              <!--                <nz-select class="w-full" formControlName="isASupplier" nzPlaceHolder="Select one">-->
              <!--                  <nz-option [nzValue]="true" nzLabel="Yes"></nz-option>-->
              <!--                  <nz-option [nzValue]="false" nzLabel="No"></nz-option>-->
              <!--                </nz-select>-->
              <!--              </nz-form-control>-->
              <!--            </nz-form-item>-->
              <!--          </div>-->
              <div *ngIf="isSrDriver">
                <nz-form-label nzRequired>Permanent or Contract</nz-form-label>
                <nz-form-item>
                  <nz-form-control [nzErrorTip]="contractOrPermanentError">
                    <nz-select nzAllowClear class="w-full" formControlName="contractOrPermanent"
                               nzPlaceHolder="Select one">
                      <nz-option nzValue="PERMANENT" nzLabel="Permanent"></nz-option>
                      <nz-option nzValue="CONTRACT" nzLabel="Contract"></nz-option>
                    </nz-select>
                  </nz-form-control>
                  <ng-template #contractOrPermanentError>
                    <span *ngIf="formErrors.contractOrPermanent.required">Please select one. </span>
                  </ng-template>
                </nz-form-item>
              </div>
            </div>
            <div class="grid grid-cols-1 gap-3 content-end">
              <div *ngIf="isOutsourceDriver">
<!--                <div class="border border-solid border-gray-400 rounded-lg p-3 mb-3">-->
<!--                  <p class="text-primary text-sm"><span class="text-black">*</span> Supplier is required: If there is no-->
<!--                    supplier to you, please register as a-->
<!--                    supplier first.</p>-->
<!--                </div>-->
                <div class="pb-3">
                  <nz-alert style="display: inline-block;" nzType="info" nzMessage="Supplier is required: If there is no supplier to you, please register as a supplier first." class="mb-3" nzShowIcon></nz-alert>
                </div>
                <div class="flex gap-3 items-center">
                  <div class="lg:w-1/2">
                    <nz-form-label nzRequired>Select Supplier</nz-form-label>
                    <nz-form-item>
                      <nz-form-control [nzErrorTip]="supplierError">
                        <nz-select nzShowSearch nzAllowClear class="w-full" formControlName="supplier"
                                   nzPlaceHolder="Select Supplier">
                          <nz-option *ngFor="let supplier of suppliers" [nzValue]="supplier?._id"
                                     [nzLabel]="supplier?.name"></nz-option>
                        </nz-select>
                      </nz-form-control>
                      <ng-template #supplierError>
                        <span *ngIf="formErrors.supplier.required">Please select a supplier. </span>
                      </ng-template>
                    </nz-form-item>
                  </div>

                  <div class="lg:w-1/2">
                    <a (click)="navigateToAddSupplier()">
                      <button nz-button class="outline-button mt-2" nz-button nzType="default" >Add New Supplier</button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </nz-card>
    </section>

    <section id="basicInfo" class="mt-8">
      <nz-card class="grid gap-4">
        <div>
          <form nz-form [formGroup]="driverForm" [nzLayout]="'vertical'">
            <h5 class="text-primary">Driver Details</h5>
            <div class="grid grid-cols-1 gap-3">
              <div class="" *ngIf="this.driverForm.get('driverSegment').value !== 'SR_DRIVER'">
                <nz-form-label nzRequired>Driver Registered or Not</nz-form-label>
                <nz-form-item>
                  <nz-form-control [nzErrorTip]="isRegisteredError">
                    <nz-select class="w-full" formControlName="isRegistered" nzPlaceHolder="Select one">
                      <nz-option [nzValue]="true" nzLabel="Registered"></nz-option>
                      <nz-option [nzValue]="false" nzLabel="Unregistered"></nz-option>
                    </nz-select>
                  </nz-form-control>
                  <ng-template #isRegisteredError>
                    <span *ngIf="formErrors.isRegistered.required">Please select one. </span>
                  </ng-template>
                </nz-form-item>
              </div>
              <div class="">
                <nz-form-label nzRequired>Driver's Full Name</nz-form-label>
                <nz-form-item>
                  <nz-form-control [nzErrorTip]="fullNameError">
                    <input nz-input type="text" placeholder="Enter Full Name"
                           formControlName="fullName"/>
                  </nz-form-control>
                  <ng-template #fullNameError>
                    <span *ngIf="formErrors.fullName.required">Please enter full name. </span>
                    <span *ngIf="formErrors.fullName.pattern">Please enter [A-Z][a-z] characters only. </span>
                  </ng-template>
                </nz-form-item>
              </div>
            </div>
            <div class="grid grid-cols-1 gap-3 content-end">
              <div>
                <nz-form-label *ngIf="isSrDriver" nzRequired>NIC Number</nz-form-label>
                <nz-form-label *ngIf="!isSrDriver">NIC Number</nz-form-label>
                <nz-form-item>
                  <nz-form-control [nzErrorTip]="nicError">
                    <input nz-input type="text" placeholder="Enter NIC Number"
                           formControlName="nicNo"/>
                  </nz-form-control>
                  <ng-template #nicError>
                    <span *ngIf="formErrors.nicNo.required">Please enter NIC number. </span>
                  </ng-template>
                </nz-form-item>
              </div>
              <div>
                <nz-form-label nzRequired>Mobile Number</nz-form-label>
                <nz-form-item>
                  <nz-form-control [nzErrorTip]="mobileError">
                    <input nz-input type="text" placeholder="Enter Mobile Number"
                           formControlName="mobileNumber"/>
                  </nz-form-control>
                  <ng-template #mobileError>
                    <span *ngIf="formErrors.mobileNumber.required">Please enter mobile number. </span>
                    <span *ngIf="formErrors.mobileNumber.pattern">Mobile number invalid. </span>
                  </ng-template>
                </nz-form-item>
              </div>
              <div>
                <nz-form-label>Email</nz-form-label>
                <nz-form-item>
                  <nz-form-control [nzErrorTip]="emailError">
                    <input nz-input type="text" placeholder="Enter Email"
                           formControlName="email"/>
                  </nz-form-control>
                  <ng-template #emailError>
                    <span *ngIf="formErrors.email.email">Email is invalid</span>
                  </ng-template>
                </nz-form-item>
              </div>
            </div>
            <div class="grid grid-cols-1 gap-3 content-end">
              <div>
                <nz-form-label>Can Drive</nz-form-label>
                <nz-form-item>
                  <nz-form-control>
                    <nz-checkbox-group class="mb-4" formControlName="canDrive"></nz-checkbox-group>
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </form>
        </div>
      </nz-card>
    </section>

    <section id="languageSkills" class="mt-8">
      <nz-card class="grid gap-4">
        <div>
          <form nz-form [formGroup]="driverForm" [nzLayout]="'vertical'">
            <h5 class="text-primary">Language Skills</h5>
            <div class="grid grid-cols-5 gap-3">
              <div class="col-span-2">
                <nz-form-label>Language</nz-form-label>
              </div>
              <div class="col-span-2">
                <nz-form-label>Level</nz-form-label>
              </div>
            </div>
            <div formArrayName="languageSkills" class="grid grid-cols-5 gap-3 content-end"
                 *ngFor="let items of languageSkills.controls; let i=index">
              <div class="col-span-2" [formGroupName]="i">
                <nz-form-item>
                  <nz-form-control>
                    <input nz-input type="text" placeholder="Enter Language" id="language{{i}}"
                           formControlName="language"/>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div class="col-span-2" [formGroupName]="i">
                <nz-form-item>
                  <nz-form-control>
                    <nz-select class="w-full" id="level{{i}}" formControlName="level" nzPlaceHolder="Select Level">
                      <nz-option nzValue="EXCELLENT"
                                 nzLabel="Excellent"></nz-option>
                                 <nz-option nzValue="INTERMEDIATE" nzLabel="Intermediate"></nz-option>
                                 <nz-option nzValue="BASIC" nzLabel="Basic"></nz-option>
                      <nz-option nzValue="POOR" nzLabel="Poor"></nz-option>

                    </nz-select>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div class="col-span-1">
                <button nz-button class="outlined" (click)="removeItem($event, i)">-</button>
              </div>
            </div>
            <div>
              <button nz-button class="outlined" (click)="addItems()">+</button>
            </div>
          </form>
        </div>
      </nz-card>
    </section>

    <section id="licenceDetails" class="mt-8">
      <nz-card class="grid gap-4">
        <div>
          <form nz-form [formGroup]="driverForm" [nzLayout]="'vertical'">
            <h5 class="text-primary">License Details</h5>
            <div formGroupName="licenseDetails" class="grid grid-cols-1 gap-3">
              <div>
                <div class="grid grid-cols-1 gap-3">
                  <div class="">
                    <nz-form-label *ngIf="isSrDriver" nzRequired>Driving Licence Expiry Date</nz-form-label>
                    <nz-form-label *ngIf="!isSrDriver">Driving Licence Expiry Date</nz-form-label>
                    <nz-form-item>
                      <nz-form-control [nzErrorTip]="licenceDateError">
                        <nz-date-picker class="w-full"
                                        placeholder="Enter Date and Time"
                                        nzFormat="yyyy-MM-dd"
                                        formControlName="drivingLicenseExpiryDate"></nz-date-picker>
                      </nz-form-control>
                      <ng-template #licenceDateError>
                        <span *ngIf="innerLicenseDetailsErrors?.licenseDetails?.drivingLicenseExpiryDate?.required">Driving license expiry date is required.</span>
                      </ng-template>
                    </nz-form-item>
                  </div>
                </div>
                <div class="grid grid-cols-1 gap-3">
                  <div class="">
                    <nz-form-label>Tourist Driver Licence</nz-form-label>
                    <nz-form-item>
                      <nz-form-control>
                        <nz-select class="w-full" formControlName="hasTourDriverLicense" nzPlaceHolder="Select one">
                          <nz-option [nzValue]="true" nzLabel="Yes"></nz-option>
                          <nz-option [nzValue]="false" nzLabel="No"></nz-option>
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div *ngIf="hasTourLicense" class="">
                    <nz-form-label>Valid Until</nz-form-label>
                    <nz-form-item>
                      <nz-form-control>
                        <nz-date-picker
                          class="w-full"
                          placeholder="Enter Date and Time"
                          nzFormat="yyyy-MM-dd"
                          formControlName="tourDriverLicenseExpiryDate"></nz-date-picker>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>
                <div class="grid grid-cols-1 gap-3">
                  <div class="">
                    <nz-form-label>Chauffeur Guide Licence</nz-form-label>
                    <nz-form-item>
                      <nz-form-control>
                        <nz-select class="w-full" formControlName="hasChauffeurGuideLicense" nzPlaceHolder="Select one">
                          <nz-option [nzValue]="true" nzLabel="Yes"></nz-option>
                          <nz-option [nzValue]="false" nzLabel="No"></nz-option>
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div *ngIf="hasChauffeurGuideLicense" class="">
                    <nz-form-label>Valid Until</nz-form-label>
                    <nz-form-item>
                      <nz-form-control>
                        <nz-date-picker
                          class="w-full"
                          placeholder="Enter Date and Time"
                          nzFormat="yyyy-MM-dd"
                          formControlName="chauffeurGuideLicenseExpiryDate"></nz-date-picker>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>

                <div class="grid grid-cols-1 gap-3">
                  <div class="">
                    <nz-form-label>National Guide Licence</nz-form-label>
                    <nz-form-item>
                      <nz-form-control>
                        <nz-select class="w-full" formControlName="hasNationalGuideLicense" nzPlaceHolder="Select one">
                          <nz-option [nzValue]="true" nzLabel="Yes"></nz-option>
                          <nz-option [nzValue]="false" nzLabel="No"></nz-option>
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div *ngIf="hasNationalGuideLicense" class="">
                    <nz-form-label>Valid Until</nz-form-label>
                    <nz-form-item>
                      <nz-form-control>
                        <nz-date-picker
                          class="w-full"
                          placeholder="Enter Date and Time"
                          nzFormat="yyyy-MM-dd"
                          formControlName="nationalGuideLicenseExpiryDate"></nz-date-picker>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </div>
              </div>
              <div>
                <h6>Attachments</h6>
                <nz-form-label>Driving Licence/ Tourist Driver Licence/ Chauffeur Guide Licence/ National Guide Licence
                </nz-form-label>

                <div class="flex flex-col items-center justify-center bg-slate-100 w-full h-32 xl:h-52 py-2">
                  <div>
                    <nz-upload
                      [nzCustomRequest]="licenceUpload" [nzShowUploadList]="false" [nzMultiple]="true">
                      <button nz-button>
                        <span nz-icon nzType="upload"></span>
                        Click to Upload
                      </button>
                    </nz-upload>
                  </div>
                  <div>
                    <p *ngIf="licenceAttachmentUploading" class="text-primary my-2">Uploading...</p>
                  </div>
                  <div class="mt-2 overflow-auto">
                    <div *ngFor="let file of licenceAttachments; let i = index"
                         class="flex justify-between items-center mx-3 gap-5">
                      <a target="_blank" href="{{file.url}}">{{file.name}}</a>
                      <span nz-icon nzType="close-circle" nzTheme="outline" [nzTheme]="'twotone'"
                            [nzTwotoneColor]="'#ff0000'"
                            class="cursor-pointer" nz-popconfirm
                            nzPopconfirmTitle="Are you sure you want to delete this attachment"
                            (nzOnConfirm)="removeAttachment(i, 'licences')"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </nz-card>
    </section>

    <!--<section *ngIf="isSrDriver" class="mt-8">-->
    <!--  <nz-card [formGroup]="driverForm" class="grig gap-4">-->
    <!--    <h5 class="text-primary">Assigns Vehicles</h5>-->
    <!--    <div class="grid grid-cols-4 gap-3">-->
    <!--      <div class="">-->
    <!--        <nz-form-label>Select Vehicle</nz-form-label>-->
    <!--        <nz-form-item>-->
    <!--          <nz-form-control>-->
    <!--            <nz-select class="w-full" formControlName="assignsVehicles" nzPlaceHolder="Select Vehicle"-->
    <!--                       nzMode="multiple">-->
    <!--              <nz-option *ngFor="let fleet of fleetOptions" nzValue="{{fleet?._id}}"-->
    <!--                         nzLabel="{{fleet?.vehicleName ? fleet?.vehicleName : '-'}}"></nz-option>-->
    <!--            </nz-select>-->
    <!--          </nz-form-control>-->
    <!--        </nz-form-item>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--  </nz-card>-->
    <!--</section>-->

    <section id="notesAndAttachments" class="mt-8">
      <nz-card class="grid gap-4">
        <div>
          <form nz-form [formGroup]="driverForm" [nzLayout]="'vertical'">
            <h5 class="text-primary">Notes and Attachments</h5>
            <div class="grid grid-cols-1 gap-3">
              <div class="">
                <nz-form-label>Notes</nz-form-label>
                <nz-form-item>
                  <nz-form-control>
                <textarea class="hidden xl:block" rows="8" nz-input formControlName="notes"
                          PlaceHolder="Enter Notes here"></textarea>
                    <textarea class="block xl:hidden" rows="5" nz-input formControlName="notes"
                              PlaceHolder="Enter Notes here"></textarea>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div class="">
                <nz-form-label>Attachments</nz-form-label>

                <div class="flex flex-col items-center justify-center bg-slate-100 w-full h-[8.5rem] xl:h-52 py-2">
                  <div>
                    <nz-upload
                      [nzCustomRequest]="otherAttachmentOnUpload" [nzShowUploadList]="false" [nzMultiple]="true">
                      <button nz-button>
                        <span nz-icon nzType="upload"></span>
                        Click to Upload
                      </button>
                    </nz-upload>
                  </div>
                  <div>
                    <p *ngIf="otherAttachmentUploading" class="text-primary my-2">Uploading...</p>
                  </div>
                  <div class="mt-2 overflow-auto">
                    <div *ngFor="let file of otherAttachments; let i = index"
                         class="flex justify-between items-center mx-3 gap-5">
                      <a target="_blank" href="{{file.url}}">{{file.name}}</a>
                      <span nz-icon nzType="close-circle" nzTheme="outline" [nzTheme]="'twotone'"
                            [nzTwotoneColor]="'#ff0000'"
                            class="cursor-pointer" nz-popconfirm
                            nzPopconfirmTitle="Are you sure you want to delete this attachment"
                            (nzOnConfirm)="removeAttachment(i, 'other')"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </nz-card>
    </section>
  </ng-container>
  <ng-container *nzModalFooter>
    <div class="flex justify-end sm:justify-end">
      <a
        nz-popconfirm
        nzPopconfirmTitle="Are you sure you want to cancel this record? you will loose all data."
        nzPopconfirmPlacement="bottom"
        (nzOnConfirm)="confirm()"
        (nzOnCancel)="cancel()"
      >
        <button class="outline-button mr-3" nz-button nzType="default">Cancel</button>
      </a>
      <button
        nz-popconfirm
        nzPopconfirmTitle="Are you sure you want to save the data?"
        nzPopconfirmPlacement="bottom"
        nz-button nzType="primary"
        (nzOnConfirm)="onSubmit()" (nzOnCancel)="cancel()" [disabled]="driverForm.invalid">Update Driver
      </button>
    </div>
  </ng-container>
</nz-modal>

<app-add-supplier-popup [isVisible]="visibleAddSupplierPopup"
                        (addEditSupplierOnChange)="onGetAddSupplierChange($event)"></app-add-supplier-popup>
